const SUBSCRIPTION_TYPES = {
  CREATE_CUSTOMER_BEGIN: "CREATE_CUSTOMER_BEGIN",
  CREATE_CUSTOMER_SUCCESS: "CREATE_CUSTOMER_SUCCESS",
  CREATE_CUSTOMER_FAILURE: "CREATE_CUSTOMER_FAILURE",

  FETCH_SUBSCRIPTION_TYPES_BEGIN: "FETCH_SUBSCRIPTION_TYPES_BEGIN",
  FETCH_SUBSCRIPTION_TYPES_SUCCESS: "FETCH_SUBSCRIPTION_TYPES_SUCCESS",
  FETCH_SUBSCRIPTION_TYPES_FAILURE: "FETCH_SUBSCRIPTION_TYPES_FAILURE",

  CHECKOUT_BEGIN: "CHECKOUT_BEGIN",
  CHECKOUT_SUCCESS: "CHECKOUT_SUCCESS",
  CHECKOUT_FAILURE: "CHECKOUT_FAILURE",

  CREATE_SUBSCRIPTION_BEGIN: "CREATE_SUBSCRIPTION_BEGIN",
  CREATE_SUBSCRIPTION_SUCCESS: "CREATE_SUBSCRIPTION_SUCCESS",
  CREATE_SUBSCRIPTION_FAILURE: "CREATE_SUBSCRIPTION_FAILURE",

  FETCH_USER_SUBSCRIPTIONS_BEGIN: "FETCH_USER_SUBSCRIPTIONS_BEGIN",
  FETCH_USER_SUBSCRIPTIONS_SUCCESS: "FETCH_USER_SUBSCRIPTIONS_SUCCESS",
  FETCH_USER_SUBSCRIPTIONS_FAILURE: "FETCH_USER_SUBSCRIPTIONS_FAILURE",

  FETCH_REFERRERS_BEGIN: "FETCH_REFERRERS_BEGIN",
  FETCH_REFERRERS_SUCCESS: "FETCH_REFERRERS_SUCCESS",
  FETCH_REFERRERS_FAILURE: "FETCH_REFERRERS_FAILURE",

  SUBMIT_REFERRER_BEGIN: "SUBMIT_REFERRER_BEGIN",
  SUBMIT_REFERRER_SUCCESS: "SUBMIT_REFERRER_SUCCESS",
  SUBMIT_REFERRER_FAILURE: "SUBMIT_REFERRER_FAILURE",

  CANCEL_SUBSCRIPTIONS_BEGIN: "CANCEL_SUBSCRIPTIONS_BEGIN",
  CANCEL_SUBSCRIPTIONS_SUCCESS: "CANCEL_SUBSCRIPTIONS_SUCCESS",
  CANCEL_SUBSCRIPTIONS_FAILURE: "CANCEL_SUBSCRIPTIONS_FAILURE",
};

export default SUBSCRIPTION_TYPES;
